module.exports = __webpack_public_path__ + "img/barbados.71da99ed.svg";